import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconBell({ color, size }: IIconProps): ReactElement {
  const theSize = size || 16;

  return (
    <svg
      width={theSize}
      height={theSize}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.5C8.55 1.5 9 1.95 9 2.5V3.1C11.06 3.55 12.5 5.38 12.5 7.5V10.5L13.8 12.1C14.05 12.42 13.82 12.9 13.41 12.9H2.59C2.18 12.9 1.95 12.42 2.2 12.1L3.5 10.5V7.5C3.5 5.38 4.94 3.55 7 3.1V2.5C7 1.95 7.45 1.5 8 1.5Z"
        fill={color || "#5A6072"}
      />
      <path
        d="M6.4 13.4H9.6C9.6 14.28 8.88 15 8 15C7.12 15 6.4 14.28 6.4 13.4Z"
        fill={color || "#5A6072"}
      />
    </svg>
  );
}
